import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "row g-3 mb-3" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "row g-3 mb-3" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "row g-3 mb-3" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "border rounded p-3 mb-3" }
const _hoisted_12 = { class: "row g-3 mb-3" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "row g-3" }
const _hoisted_16 = { class: "col-md-4" }
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = { class: "d-flex justify-content-end gap-2 mt-3" }
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueInputText = _resolveComponent("PrimevueInputText")!
  const _component_PrimevueInputNumber = _resolveComponent("PrimevueInputNumber")!
  const _component_PrimevueTextarea = _resolveComponent("PrimevueTextarea")!
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Nom complet *", -1)),
      _createVNode(_component_PrimevueInputText, {
        class: "w-100",
        modelValue: _ctx.form.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
        required: ""
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Téléphone", -1)),
        _createVNode(_component_PrimevueInputText, {
          class: "w-100",
          modelValue: _ctx.form.phone,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.phone) = $event)),
          type: "tel",
          placeholder: "+241...",
          onInput: _ctx.sanitizePhoneField
        }, null, 8, ["modelValue", "onInput"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "WhatsApp", -1)),
        _createVNode(_component_PrimevueInputText, {
          class: "w-100",
          modelValue: _ctx.form.whatsapp_phone,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.whatsapp_phone) = $event)),
          type: "tel",
          placeholder: "+241...",
          onInput: _ctx.sanitizeWhatsappField
        }, null, 8, ["modelValue", "onInput"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Email", -1)),
        _createVNode(_component_PrimevueInputText, {
          type: "email",
          class: "w-100",
          modelValue: _ctx.form.email,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.email) = $event)),
          placeholder: "client@example.com"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Ville", -1)),
        _createVNode(_component_PrimevueInputText, {
          class: "w-100",
          modelValue: _ctx.form.city,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.city) = $event)),
          placeholder: "Libreville, ... "
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Adresse", -1)),
        _createVNode(_component_PrimevueInputText, {
          class: "w-100",
          modelValue: _ctx.form.address,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.address) = $event)),
          placeholder: "Adresse complète"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[20] || (_cache[20] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Plafond dette", -1)),
      _createVNode(_component_PrimevueInputNumber, {
        modelValue: _ctx.form.debt_limit,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.debt_limit) = $event)),
        class: "w-100",
        mode: "decimal",
        min: 0,
        maxFractionDigits: 2
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _cache[26] || (_cache[26] = _createElementVNode("h6", { class: "mb-3" }, "Pièce d'identité", -1)),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Type de pièce", -1)),
          _createVNode(_component_PrimevueInputText, {
            id: "clientIdentityType",
            class: "w-100",
            modelValue: _ctx.form.identity_document_type,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.identity_document_type) = $event)),
            placeholder: "CNI, passeport..."
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[22] || (_cache[22] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Numéro de pièce", -1)),
          _createVNode(_component_PrimevueInputText, {
            id: "clientIdentityNumber",
            class: "w-100",
            modelValue: _ctx.form.identity_document_number,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.identity_document_number) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Pays d'émission", -1)),
          _createVNode(_component_PrimevueInputText, {
            id: "clientIdentityCountry",
            class: "w-100",
            modelValue: _ctx.form.identity_document_country,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.identity_document_country) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _cache[24] || (_cache[24] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Date d'émission", -1)),
          _createVNode(_component_PrimevueInputText, {
            id: "clientIdentityIssuedAt",
            class: "w-100",
            modelValue: _ctx.form.identity_document_issued_at,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.identity_document_issued_at) = $event)),
            type: "date"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[25] || (_cache[25] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Date d'expiration", -1)),
          _createVNode(_component_PrimevueInputText, {
            id: "clientIdentityExpiresAt",
            class: "w-100",
            modelValue: _ctx.form.identity_document_expires_at,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.identity_document_expires_at) = $event)),
            type: "date"
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _cache[27] || (_cache[27] = _createElementVNode("label", { class: "form-label small fw-semibold" }, "Notes", -1)),
      _createVNode(_component_PrimevueTextarea, {
        class: "w-100",
        rows: "2",
        modelValue: _ctx.form.notes,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.notes) = $event)),
        autoResize: "",
        placeholder: "Informations particulières sur ce client"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline-secondary btn-sm",
        disabled: _ctx.submitting,
        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('cancel')))
      }, [...(_cache[28] || (_cache[28] = [
        _createElementVNode("i", {
          class: "fa fa-xmark me-1",
          "aria-hidden": "true"
        }, null, -1),
        _createTextVNode(" Annuler ", -1)
      ]))], 8, _hoisted_21),
      _createVNode(_component_AppLoadingButton, {
        type: "button",
        class: "btn btn-primary btn-sm",
        loading: _ctx.submitting,
        "loading-label": "Enregistrement...",
        onClick: _ctx.submit
      }, {
        default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
          _createElementVNode("i", { class: "fa fa-save me-1" }, null, -1),
          _createTextVNode(" Enregistrer ", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "onClick"])
    ])
  ]))
}